import { render, staticRenderFns } from "./PeopleSearch.vue?vue&type=template&id=ad485db8&scoped=true&"
import script from "./PeopleSearch.vue?vue&type=script&lang=js&"
export * from "./PeopleSearch.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSearch.vue?vue&type=style&index=0&id=ad485db8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad485db8",
  null
  
)

export default component.exports